import type {TestimonialListSelectionFragment} from '@/components/content-blocks/testimonial-list-selection/query';
import {imageWebFromImageWebSchema} from '@/components/image/query';
import type {TestimonialDetails} from '@/components/testimonial/types';

export const TESTIMONIAL_FRAGMENT = `//groq
	...,
	person-> {
		name,
		image,
		role
	},
	client-> {
		name,
		image
	}
`;

export type TestimonialFragment = NonNullable<
	TestimonialListSelectionFragment['testimonials']
>[number];

export function testimonialFragmentToTestimonialDetails(
	testimonial: TestimonialFragment,
): TestimonialDetails {
	const imageToUse = testimonial?.person?.image?.asset
		? testimonial.person.image
		: testimonial.client?.image?.asset
			? testimonial.client.image
			: null;
	const image = imageToUse?.asset
		? imageWebFromImageWebSchema(imageToUse, 1)
		: null;

	let customer = '';
	if (testimonial.person?.name) {
		customer = testimonial.client?.name ?? '';
	}

	return {
		name: testimonial.person?.name ?? testimonial.client?.name ?? '',
		imageWeb: image ?? undefined,
		quote: testimonial.quote ?? '',
		role: testimonial.person?.role ?? '',
		customer: customer,
	};
}
